var _style, _defs, _defs2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewExpensifyStg = function SvgNewExpensifyStg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "new-expensify-stg_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 80 81",
    style: {
      enableBackground: "new 0 0 80 81"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".new-expensify-stg_svg__st2{fill:#03d47c}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "new-expensify-stg_svg__SVGID_1_",
    d: "M0 0h80v80H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "new-expensify-stg_svg__SVGID_00000109719144377725207580000013806727012004235438_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#new-expensify-stg_svg__SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#new-expensify-stg_svg__SVGID_00000109719144377725207580000013806727012004235438_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "new-expensify-stg_svg__SVGID_00000159430450497752522510000010196965817956746124_",
    d: "M0 0h80v80H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "new-expensify-stg_svg__SVGID_00000039849557488091876660000011033855870603973786_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#new-expensify-stg_svg__SVGID_00000159430450497752522510000010196965817956746124_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#new-expensify-stg_svg__SVGID_00000039849557488091876660000011033855870603973786_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "new-expensify-stg_svg__st2",
    d: "M54.1 28.2v-8.3H25.9v40.3h28.2v-8.3H36.3v-7.7h14.4v-8.5H36.3v-7.3h17.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "new-expensify-stg_svg__st2",
    d: "M40 6.5c7.1 0 13.7 2.2 19.2 6 1.4 1 3.3.9 4.5-.3 1.3-1.3 1.3-3.5-.3-4.7C56.8 2.8 48.7 0 40 0 17.9 0 0 17.9 0 40c0 8.7 2.8 16.8 7.5 23.3 1.1 1.5 3.3 1.6 4.7.3 1.2-1.2 1.3-3.1.3-4.5-3.8-5.4-6-12-6-19.2 0-18.4 15-33.4 33.5-33.4zM73 17.4c-1.1-1.6-3.4-1.7-4.7-.3-1.2 1.2-1.3 3-.4 4.4 3.5 5.3 5.6 11.7 5.6 18.5 0 6.8-2.1 13.4-5.8 18.8-.9 1.4-.9 3.3.3 4.5 1.4 1.4 3.6 1.3 4.7-.3 4.6-6.5 7.3-14.4 7.3-23 0-8.5-2.6-16.2-7-22.6zM40 73.5c-6.8 0-13.2-2.1-18.5-5.6-1.4-.9-3.3-.8-4.4.4-1.4 1.4-1.3 3.6.3 4.7 6.4 4.4 14.2 7 22.6 7 8.4 0 16.4-2.7 23-7.3 1.6-1.1 1.7-3.3.3-4.7-1.2-1.2-3.1-1.3-4.5-.3-5.3 3.6-11.8 5.8-18.8 5.8z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M58 60h12c5.5 0 10 4.5 10 10s-4.5 10-10 10H58c-5.5 0-10-4.5-10-10s4.5-10 10-10z",
    style: {
      fill: "#008c59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9 73.1c1.5 0 2.5-.7 2.5-2 0-1-.5-1.5-2-1.8l-.8-.2c-.8-.2-1-.4-1-.7 0-.5.4-.7 1.1-.7.8 0 1.2.3 1.3 1h1.3c-.1-1.3-.9-2.1-2.5-2.1s-2.4.8-2.4 1.9c0 1 .5 1.5 1.9 1.8l.8.2c.8.2 1 .4 1 .8 0 .5-.5.8-1.3.8-.9 0-1.4-.4-1.4-1.1h-1.3c.2 1.3 1.2 2.1 2.8 2.1zm6-.1v-5.1h1.8v-1.2h-4.9v1.2h1.8V73h1.3zm2.1-3.2c0 2 1.3 3.3 3.1 3.3 1.7 0 3-1.2 3-3.2v-.3h-2.9v1.1h1.6c-.3.9-.8 1.3-1.6 1.3-1.1 0-1.9-.8-1.9-2.1s.7-2.1 1.8-2.1c.8 0 1.4.4 1.6 1.1H72c-.3-1.4-1.4-2.2-2.9-2.2-1.8-.1-3.1 1.2-3.1 3.1z",
    style: {
      fill: "#fff"
    }
  })));
};
export default SvgNewExpensifyStg;